
import { Component, Mixins, Prop } from "vue-property-decorator";
import { Document, IDocumentRegistrationResultRegisteredDetail, IDocumentFactoryRegistrationPostMessage, DocumentRegistrationResult } from "../../../domain/document";
import { default as DocumentsPrintViewMixin } from "./DocumentsPrintViewMixin.vue";

@Component
export default class DocumentsRegisterViewMixin extends Mixins(DocumentsPrintViewMixin) {
  @Prop()
  isTemporary: boolean;

  @Prop()
  shouldPrint: boolean;

  @Prop()
  systemKey: string;

  @Prop()
  linkKey: string;

  @Prop()
  orderNo: string;

  @Prop()
  postRegistrationProcess: (id: number) => Promise<void>;

  @Prop()
  shouldNotifyRegistered: boolean;

  get emptyHisKeys(): string[] {
    // v1のPARAM_PUT_REPORT_HIS_AUTO_INPUT設定相当の設定として追加されてるのでNewDocumentsRegisterViewにのみ適用.
    return this.$configuration.behavior.document.registerNewDocuments.his.emptyKeys;
  }

  async registerDocumentAndPrint(document: Document): Promise<DocumentRegistrationResult> {
    this.$logger.info("文書を登録します.");
    const result = await this.registerDocument(document, this.isTemporary, false);
    if (!result || !result.isRegistered) {
      throw new Error("文書登録できませんでした."); // 新規文書の場合はバグしかなさそうだが念のため.
    }
    const resultDetail = result.detail as IDocumentRegistrationResultRegisteredDetail;
    const documentId = resultDetail.id;
    this.$logger.info("文書(文書ID:" + documentId + ")を登録しました.");
    if (this.postRegistrationProcess) {
      await this.postRegistrationProcess(documentId);
    }
    if (this.shouldPrintDocumentExchangePaper(document, resultDetail.isFirstNormalRegister)) {
      await this.printDocumentExchangePaper(this.patientNo, documentId);
      await this.$sleep(200); // 引換証はあとから印刷できないので、念のためSleepを入れている
    }
    if (this.shouldPrint) {
      await this.printDocument(documentId, !this.isTemporary);
    }
    return result;
  }

  async registerExistingDocument(document: Document, shouldRegisterChainedDocumentOnly: boolean = true): Promise<DocumentRegistrationResult> {
    return shouldRegisterChainedDocumentOnly
      ? this.registerChainedDocument(document)
      : this.registerDocumentAndPrint(document);
  }

  async registerChainedDocument(document: Document): Promise<DocumentRegistrationResult> {
    try {
      this.$logger.info("連鎖先文書を登録します.");
      const result = await this.registerChainedDocuments(document, this.isTemporary, false);
      const resultDetail = result.detail as IDocumentRegistrationResultRegisteredDetail;
      const documentId = resultDetail.id;
      this.$logger.info("連鎖先文書(連鎖元文書ID:" + documentId + ")を登録しました.");
      // postRegistrationProcessは文書登録後に連携情報を登録するのに使っていたようですが今は未使用
      // 差し込める仕掛けとして残してあるそうなのでDocumentRegistererと同様にしておく
      if (this.postRegistrationProcess) {
        await this.postRegistrationProcess(documentId);
      }
      return result;
    } catch (e) {
      console.log(e);
      throw e;
    }
  }

  postMessages(messages: IDocumentFactoryRegistrationPostMessage[]): void {
    try {
      if (window.parent) {
        window.parent.postMessage(JSON.stringify(messages), "*");
      }
    } catch (e) {
      console.log(e);
    }
  }
}
